import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
    loading: false,
    withdrawalRequests: [],
    changedStatus: {},
    error: null,
};

const WithdrawalReducer = (state = initialState, action) => {
    // get all withdraw requests
    switch (action.type) {
        case actionTypes.WITHDRAWAL_REQUESTS_LIST_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.WITHDRAWAL_REQUESTS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                withdrawalRequests: action.payload,
                error: null,
            };
        case actionTypes.WITHDRAWAL_REQUESTS_LIST_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // change the status of withdraw request
        case actionTypes.CHANGE_REQUEST_STATUS_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.CHANGE_REQUEST_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                changedStatus: action.payload,
                error: null,
            };
        case actionTypes.CHANGE_REQUEST_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default WithdrawalReducer;
